export default "__VITE_ASSET__B0maU5tF__"